import React, {Component} from 'react';
import request from 'superagent';
import {Tabs} from 'antd';
import AlertConfigurationServiceList from './AlertConfigurationServiceList.js';
import AlertConfigurationPlatformList from './AlertConfigurationPlatformList.js'
import AlertConfigurationServiceDetail from './AlertConfigurationServiceDetail.js';
import AlertConfigurationNotification from './AlertConfigurationNotification.js'

class AlertConfiguration extends Component {

    state = {
        saData: [],
        paData: [],
        notifications: {},
        loading: false,
        showServiceAlert: ''
    };

    componentDidMount() {
        document.querySelector('#configuration-back-to-dashboard').addEventListener('click', this.props.backToDashboard, false);
        this.fetch();
    }

    fetch = () => {
        this.setState({loading: true});
        request.get('/api/dashboard/alert/configuration')
            .withCredentials()
            .end((error, response) => {
                if (!error && response) {
                    const data = response.body;
                    const saData = data.saData;
                    const paData = data.paData;
                    const notifications = data.notifications;

                    this.setState({
                        loading: false,
                        saData: saData,
                        paData: paData,
                        notifications: notifications
                    });
                }
            });
    }

    updateShowServiceAlert = (params = {}) => {
        this.setState({showServiceAlert: params});
    }

    closeDetail = () => {
        this.setState({showServiceAlert: ''});
    }

    render() {
        const saData = this.state.saData;
        const paData = this.state.paData;
        const notifications = this.state.notifications;
        const loading = this.state.loading;
        const showServiceAlert = this.state.showServiceAlert;

        return (
            <div className="page-container">
                <div className="row">
                    <div className={`${showServiceAlert === '' ? 'col-md-12': 'col-md-5'} list`}>
                        <h2 className="page-title"><a href="#" id="configuration-back-to-dashboard">Dashboard</a> &gt; Alert Rules</h2>
                        <Tabs className="system-usage-tab alert-config-tab" type="card">
                            <Tabs.TabPane tab={<span><i className="tab-service-alert"/>Service Alert</span>} key="1">
                                <AlertConfigurationServiceList saData={saData} loading={loading} showServiceAlert={showServiceAlert} updateShowServiceAlert={this.updateShowServiceAlert}/>
                            </Tabs.TabPane>
                            <Tabs.TabPane tab={<span><i className="tab-platform-alert"/>Platform Alert</span>} key="2" disabled={showServiceAlert !== ''}>
                                <AlertConfigurationPlatformList paData={paData} loading={loading} onSuccess={this.fetch}/>
                            </Tabs.TabPane>
                            <Tabs.TabPane tab={<span><i className="tab-notification"/>Notification</span>} key="3" disabled={showServiceAlert !== ''}>
                                <AlertConfigurationNotification notifications={notifications} loading={loading} onSuccess={this.fetch}/>
                            </Tabs.TabPane>
                        </Tabs>
                    </div>
                    <div className={`${showServiceAlert === '' ? 'col-md-0': 'col-md-7'} detailInfo`}>
                        {showServiceAlert === '' ? ('') : (
                                <div className=''>
                                    <AlertConfigurationServiceDetail saData={saData} showServiceAlert={showServiceAlert} close={this.closeDetail} onSuccess={this.fetch}/>
                                </div>
                            )}
                    </div>
                </div>
            </div>
        );
    }
}
export default AlertConfiguration;


// WEBPACK FOOTER //
// ./src/modules/dashboard/alert-configuration/AlertConfiguration.js